import { Flex, Spinner, Text } from '@chakra-ui/react'

const LoadingSection = () => {
  return (
    <Flex w="100%" h="calc(80vh)" alignItems="center" justifyContent="center" direction="column" gap="5">
      <Spinner color="teal" size="xl" zIndex="1001" />
      <Text color="black">Loading</Text>
    </Flex>
  )
}

export default LoadingSection
